import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingPageComponent } from './containers/landing-page/landing-page.component';
import { LandingPageGuard, LandingPageMetaGuard } from './guards';
import { provideState } from '@ngrx/store';

import * as fromStore from './store';
import { provideEffects } from '@ngrx/effects';
import { LandingPageHeaderThemeGuard } from './guards/landing-page-header-theme.guard';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: LandingPageComponent,
        canActivate: [LandingPageGuard, LandingPageMetaGuard, LandingPageHeaderThemeGuard],
        data: {
          slug: 'home',
        },
      },
      {
        path: ':slug',
        component: LandingPageComponent,
        canActivate: [LandingPageGuard, LandingPageMetaGuard, LandingPageHeaderThemeGuard],
      },
    ],

    providers: [
      provideState(fromStore.featureKey, fromStore.reducers, {
        metaReducers: fromStore.metaReducers,
      }),
      provideEffects(fromStore.effects),
    ],
  },
];
